import { ContentEdit } from '@fs/zion-icon'
import { ListItem } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { getMostRecentFieldValue } from '@fs/zion-sls'
import { useSharedBrowserStateContext } from '../../../../../shared/providers/sharedBrowserProvider/SharedBrowserContext'
import { useR2DispatchContext } from '../../../../providers/r2Provider/R2Context'
import { useSetFocusedIndex } from '../../../../components/r2imageBrowser/hooks'
import { useOverlayContext } from '../../../../../shared/providers/overlayContextProvider/OverlayContext'

export default function EditDanglingFieldButton({ field }) {
  const [t] = useTranslation()
  const { focusedIndex, thumbnails } = useSharedBrowserStateContext()
  const dispatch = useR2DispatchContext()
  const { openOverlay } = useOverlayContext()
  const setFocusedIndex = useSetFocusedIndex()

  return (
    <ListItem
      data-testid={field?.fieldType || field?.elementType}
      overline={field.displayLabel}
      primaryText={getMostRecentFieldValue(field) || ''}
      secondaryText={t(
        'edit-event.shared-house-number.caption',
        'Information is highlighted on a different page. Edit in context.'
      )}
      endElement={<ListItem.Icon Icon={ContentEdit} />}
      onClick={() => {
        const imageIdx = thumbnails.findIndex((tn) => tn.ark === field.partitionKey)
        dispatch({
          type: 'BATCH_DISPATCHES',
          value: [
            { type: 'SET_ACTIVE_FIELD_ID', value: field.id },
            { type: 'SET_PREVIOUS_FOCUSED_INDEX', value: focusedIndex },
          ],
        })
        setFocusedIndex(imageIdx, true)

        openOverlay('editDanglingField')
      }}
    />
  )
}
